import { BilliardsIcon } from './BilliardsIcon';

/**
 * author: Michael Richins
 * id 6FFE2C93-4350-4706-9694-1674F96855EA
 * name billiards
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/billiards.svg
 * tags
 * - Sport 
 */
export const EightBallIcon = BilliardsIcon;
export default EightBallIcon